import * as Dialog from '@radix-ui/react-dialog';
import { useState, useEffect, useRef } from 'react';
import { FiX, FiCheck, FiMapPin } from 'react-icons/fi';
import SmartImg from "assets/Smart.jpg";
import EnergyImg from "assets/Energy.jpg"; // Fix the typo
import CyberImg from "assets/CyberImg.jpg";
import Logo from "assets/symbol-logo.png";
import NewProjectForm from './Form/ProjectForm';
import { BorderGradient, SmallLoader } from 'processhub-components-lib';
import { AddNewItemBtn } from 'components/shared/buttons/AddNewItemBtn';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { RemoveItemBtn } from 'components/shared/buttons/RemoveItemBtn';
import Stepper from './Form/Stepper';
import { assetContent, ConnectionProfile } from '@/lib/constants';
import DropZone from 'components/tickets/DropZone';
import { IoIosArrowRoundBack } from "react-icons/io";
import AssetDropZone from './AssetDropZone';

interface MultiStepModalProps {
  from: string;
  isOpen: boolean;
  mode: string;
  formState: any;
  selectedProject: any;
  selectedOrganization: any;
  isLoading: boolean;
  step: number;
  selectedOption: string | null;
  activeTab?: string;
  selectedAsset: string | null;
  showUploadZone: boolean;
  connectionProfiles: ConnectionProfile[];
  isAgreementChecked: boolean;
  uploadBoxFilePreview: string;
  setStep: (step: number) => void;
  setSelectedOption: (selectedOption: string | null) => void;
  onClose: () => void;
  setRefreshMode: (mode: string) => void;
  setError: (error: string) => void;
  setFormState: (formState: any) => void;
  setIsLoading: (isLoading: boolean) => void;
  setNewProjectModal: (newProjectModal: boolean) => void;
  setSelectedAsset: React.Dispatch<React.SetStateAction<string | null>>;
  setConnectionProfiles: React.Dispatch<React.SetStateAction<ConnectionProfile[]>>;
  setIsAgreementChecked: React.Dispatch<React.SetStateAction<boolean>>;
  setUploadBoxFilePreview: React.Dispatch<React.SetStateAction<string>>;
  setShowUploadZone: React.Dispatch<React.SetStateAction<boolean>>;
}
const steps = [
  { number: 1, label: "Select Industry" },
  { number: 2, label: "Fill Details" },
  { number: 3, label: "Your Assets" },
  { number: 4, label: "Agreement" },
  { number: 5, label: "Confirm Details" },
];
const progressSteps = [
  { number: 1, label: "Select Industry" },
  { number: 2, label: "Fill Details" },
  { number: 3, label: "As-Planned model" },
  { number: 4, label: "Agreement" },
  { number: 5, label: "Confirm Details" },
];

export default function ProjectMultiStepModal({from, isLoading, isOpen, showUploadZone, onClose, setRefreshMode, setError, mode, formState, setFormState, setIsLoading, selectedOrganization, selectedProject, setNewProjectModal, step, setStep, selectedOption, setSelectedOption, activeTab, selectedAsset, setSelectedAsset, connectionProfiles, setConnectionProfiles, isAgreementChecked, setIsAgreementChecked, setShowUploadZone, setUploadBoxFilePreview }: MultiStepModalProps) {
  console.log("selectedProject in modal", selectedProject);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [submitProjectForm, setSubmitProjectForm] = useState<(() => void) | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  // Keep track of the form data across steps
  const [formDataSnapshot, setFormDataSnapshot] = useState(formState);

  // When formState changes, update our snapshot
  useEffect(() => {
    if (formState) {
      setFormDataSnapshot(formState);
    }
  }, [formState]);



  // Add some debug info to the console to help track which tab is active
  useEffect(() => {
    if (isOpen && mode === 'create') {
      console.log('Creating project in tab:', activeTab || 'operational', step);
    }
  }, [isOpen, mode, activeTab]);
  useEffect(() => {
    console.log("active step", step);
    console.log("active tab", activeTab);
  }, [step]);

  // When navigating steps, keep our form data
  const goNext = () => {
    setStep(step + 1);
  };

  const goBack = () => {
    // Preserve the current form data when going back
    setStep(step - 1);
  };

  const getBackgroundImage = (category: string) => {
    switch (category?.toLowerCase()) {
      case "smart":
        return SmartImg;
      case "energy":
        return EnergyImg;
      case "cyber":
        return CyberImg;
      default:
        return SmartImg;
    }
  };

  const options = [
    {
      title: 'Energy',
      image: getBackgroundImage('energy'),
      value: 'ENERGY'
    },
    {
      title: 'Smart City',
      image: getBackgroundImage('smart'),
      value: 'SMARTCITY'
    },
    {
      title: 'Cyber Security',
      image: getBackgroundImage('cyber'),
      value: 'CYBERSECURITY'
    }
  ];

  const handleClose = () => {
    // Only reset step but preserve form data
    setStep(1);

    // If we're closing entirely, notify parent
    onClose();
  };


  const openModal = () => setIsModalOpen(true);

  const handleSubmitFromStep3 = async () => {
    if (submitProjectForm) {
      // When submitting, pass information about which tab we're in
      submitProjectForm();
    }
  };

  // Function to save the submit handler from ProjectForm
  const handleSaveSubmitFunction = (submitFn: () => void) => {
    setSubmitProjectForm(() => submitFn);
  };

  const handleStepChange = (stepCircle: number) => {
    if (stepCircle === 2 && step === 1) {
      if (!selectedOption) return;
    }
    if (stepCircle === 3 && step === 2) {
      if (!formState.projectName || !formState.productLocation) return;
    }
    if (stepCircle === 3 && step === 1) {
      return;
    }

    setStep(stepCircle);
  };

  const handleAssetUpload = () => {
    // setStep(step + 1);
    // setShowUploadZone(true);
  };

  const handleAddConnectionProfile = () => {

    const connectionProfile = {
      id: Math.floor(Math.random() * 100).toString(),
      title: "Exel (P3)",
      status: "Imported"
    };
    setConnectionProfiles([...connectionProfiles, connectionProfile]);
  };

  const handleConnectionProfileDelete = (id: string) => {
    const filteredConnectionProifles = connectionProfiles.filter((connectionProfile) => connectionProfile.id !== id);
    setConnectionProfiles(filteredConnectionProifles);
  };

  const handleAgreementCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsAgreementChecked(event.target.checked);
    console.log('Checked:', event.target.checked);
  };

  const handleUploadBoxClick = () => {
    fileInputRef.current?.click();
  };

  const handleUploadBoxFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setUploadBoxFilePreview(previewURL);
      console.log('Selected file:', file.name);
    }
  };

  const handleSkip = () => {
    setStep(step + 1);
  };
  return (
    <Dialog.Root open={isOpen} onOpenChange={handleClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/60 z-50" />
        <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[90vw] lg:w-[1024px] h-[70vh]">
          {/* <BorderGradient className='rounded-lg flex flex-col h-full w-full'> */}
          <div className="bg-[#1A1A1A]/90 rounded-lg  relative text-white  flex flex-col h-full">
            {/* Close Button */}


            {/* Navigation */}
            {mode === "create" ? (
              <div className="flex justify-center gap-10 p-6 py-4  sticky top-0 bg-[#1A1A1A]/0 items-center   w-full z-10 rounded-lg mt-2">
                {/* <button
                  onClick={handleClose}
                  className="absolute top-[28px] right-4 text-gray-400 hover:text-white"
                >
                  <FiX size={24} />
                </button> */}

                {/* {activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step !== 1 && step !== 2 && step !== 4 && step !== 5 && step !== 6 && <h4 onClick={handleSkip} className="absolute top-[28px] underline left-6 text-gray-400 hover:text-white cursor-pointer">Skip</h4>} */}
{/* 
                {step !== 1 ? (
                  <div className={`p-[1.5px] rounded-md ${selectedOption ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                    <button
                      onClick={goBack}
                      className={`flex flex-row items-center gap-2 ${selectedOption ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                    >

                      Back
                    </button>
                  </div>
                ) : (
                  <div className="w-[44px]" />
                )} */}

                <div className=" justify-center">
                  <Stepper steps={activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" ? steps : progressSteps} handleStepChange={handleStepChange} currentStep={step} />
                </div>

                {/* <div className="flex justify-end">
                  {step === 1 && (
                    <>
                      <div className={`p-[1.5px] rounded-md ${selectedOption ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 ${selectedOption ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                          disabled={!selectedOption}
                        >
                         <SlArrowRight /> 
                          
                        </button>
                      </div>
                    </>
                  )} */}
                  {/* {activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step === 3 && (
                    <>
                      <div className={`p-[1.5px] rounded-md ${selectedAsset ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 ${selectedAsset ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                          disabled={!selectedAsset}
                        >
                          <SlArrowRight /> 
                          Continue
                        </button>
                      </div>
                    </>
                  )} */}
                  {/* {activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 3 && (
                     <div className={`p-[1.5px] rounded-md bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] relative bottom-[10px]`}>
                     <button
                       onClick={goNext}
                       className={`flex flex-row items-center gap-2  bg-[#2A2A2A] hover:bg-[#3a3a3a33] rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
               
                     >
                       <SlArrowRight /> 
                       Continue
                     </button>
                   </div>
                  )
                  } */}

                  {/* {activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4 && (
                      <>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold  mb-[25px] ${selectedAsset
                            ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white hover:opacity-90'
                            : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'
                            }`}
                          disabled={!selectedAsset}
                        >
                          <SlArrowRight />
                        </button>
                      </>
                    )} */}

                  {/* {step === 5 && (
                      <>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold  mb-[25px] ${selectedAsset
                            ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white hover:opacity-90'
                            : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'
                            }`}
                          disabled={!selectedAsset}
                        >
                          <SlArrowRight />
                        </button>
                      </>
                    )} */}
                  {/* ((mode === "create" && step === 5) || (activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step === 3)) */}

                  {/* {mode === "create" && activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4 && (
                      <>
                        <div className="p-[1.5px] rounded-md bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] relative bottom-[10px]">
                          <button
                            onClick={goNext}
                            className="flex flex-row items-center gap-2 bg-[#2A2A2A] hover:bg-[#3a3a3a33] rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full"
                          >
                            <SlArrowRight />
                          </button>
                        </div>
                      </>
                    )} */}

                  {/* {((mode === "create" && activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4) || (activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4)) && (
                    <>
                      <div className={`p-[1.5px] rounded-md ${isAgreementChecked ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 ${isAgreementChecked ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                          disabled={!isAgreementChecked}
                        >
                          Continue
                        </button>
                      </div>
                    </>
                  )} */}

                  {/* {step === 2 && (
                    <div className={`p-[1.5px] rounded-md ${formState.projectName && formState.productLocation ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                      <button
                        onClick={goNext}
                        className={`flex flex-row items-center gap-2 ${formState.projectName && formState.productLocation ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                        disabled={!formState.projectName || !formState.productLocation}
                      >
                        Continue
                      </button>
                    </div>
                  )} */}

                  {/* {step === 6 && ( */}
                  {/* {((mode === "create" && step === 5) || (activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 5)) && (
                    <div className="p-[1.5px] rounded-md bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] relative bottom-[10px]">
                      <AddNewItemBtn
                        onClick={handleSubmitFromStep3}
                        className='bg-[#2A2A2A] hover:bg-[#3a3a3a33] text-white hover:opacity-90 w-full h-full'
                        btnType="filled"
                        type="button"
                        isDisabled={isLoading || !submitProjectForm}
                      >
                        {isLoading ? (
                          <SmallLoader />
                        ) : (
                          <div className="flex items-center">
                            <FiCheck className="mr-2" />
                            <span> Create</span>
                          </div>
                        )}
                      </AddNewItemBtn>
                    </div>
                  )} */}
                </div>
              // </div>
            ) : (
              <div className='mt-5'>
           {/* <div className="flex justify-end items-center mt-5">
             <div className="flex gap-2 items-center">
               <RemoveItemBtn
                 onClick={openModal}
                 isDisabled={false}
                 type="button"
               >
                 Remove Project
               </RemoveItemBtn>

               <AddNewItemBtn
                 btnType="filled"
                 type="button"
                 isDisabled={isLoading}
                 className='mr-3'
                 onClick={handleSubmitFromStep3}
               >
                 {isLoading ? <SmallLoader /> : <span>Edit Project</span>}
               </AddNewItemBtn>
             </div>
           </div> */}
              </div>
            )}


            {/* Step content */}
            <div className=" flex-grow flex flex-col px-6 h-[calc(70vh-87px)] overflow-y-auto ">
              {mode === "create" && step === 1 && (
                <div className="flex flex-col h-full p-6">
                  {/* <h2 className="text-2xl font-semibold mb-6">What are you building?</h2> */}
                  <div className="grid grid-cols-3 gap-1 h-full">
                    {options.map((option) => (
                      <button
                        key={option.title}
                        onClick={() => setSelectedOption(option.value)}
                        className={`relative h-full rounded-lg p-2 transition-all duration-200 hover:scale-105 ${selectedOption === option.value ? 'ring-2 ring-[#c7c7c7]' : ''
                          }`}
                      >
                        <div
                          className={`flex flex-col items-center justify-center h-full w-full space-y-4 bg-cover bg-center transition-opacity duration-200 rounded-md ${selectedOption === option.title ? 'opacity-100' : 'opacity-50 hover:opacity-75'
                            }`}
                          style={{ backgroundImage: `url(${option.image})`, position: "relative" }}
                        >
                          <div className="absolute inset-0 bg-black/40 rounded-md"></div>
                          <div className="text-center relative z-10">
                            <div className="flex items-center mb-4 justify-center">
                              <img src={Logo} alt="logo" className="h-[50px] w-[60px]" />
                            </div>
                            <p><span className='font-bold'>Process</span>Hub</p>
                            <p className="text-white text-lg font-semibold mt-2">{option.title}</p>
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {mode === "create" && step === 2 && (
                <div className="h-full ">
                  <NewProjectForm
                    setStep={setStep}
                    onSaveSubmitFunction={handleSaveSubmitFunction}
                    setIsModalOpen={setIsModalOpen}
                    isModalOpen={isModalOpen}
                    goNext={goNext}
                    goBack={goBack}
                    step={step}
                    selectedOption={selectedOption}
                    isLoading={isLoading}
                    setNewProjectModal={setNewProjectModal}
                    setRefreshMode={setRefreshMode}
                    setError={setError}
                    mode="create"
                    formState={formState}
                    setFormState={setFormState}
                    setIsLoading={setIsLoading}
                    selectedOrganization={selectedOrganization}
                    selectedProject={selectedProject}
                    activeTab={activeTab}
                  />
                </div>
              )}

              {activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && mode === "create" && step === 3 && (
                <div className="h-full">
                  <h3 className='text-xl font-semibold'>Get Your Asset</h3>
                  {assetContent && assetContent.length > 0 && assetContent.map((asset) => {
                    return (
                      <BorderGradient key={asset.id} className={`w-full bg-gray    mt-5 rounded-lg  hover:opacity-[1]  ${selectedAsset === asset.id ? "opacity-[1]" : "opacity-[0.7]"}`}>
                        <div onClick={() => setSelectedAsset(asset.id)} className={`bg-[#1A1A1A] rounded-lg overflow-hidden  h-[140px] p-4 flex items-center  `}>
                          <div className="content">
                            <h3 className='text-lg'>{asset.title}</h3>
                            <p className='sm:w-[75%] mt-5 text-sm leading-6'>{asset.desc}</p>
                          </div>
                          <div className="upload-icon group" onClick={handleAssetUpload}>
                            {/* <img src='/icons/upload-icon.png' className='group-hover:scale-[1] scale-[0.8] p-2 py-2 rounded-md bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white hover:opacity-90 transition-all duration-300 ease-in-out cursor-pointer' /> */}
                            <AssetDropZone
                              onFilesAdded={(files) => setFormState({ ...formState, assetAttachments: files })}
                            />
                          </div>
                        </div>
                      </BorderGradient>
                    );
                  })}
                  <br />
                </div>
              )}

              {activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && mode === "create" && step === 3 && (
                <div className="h-full ">
                  <div className="text-[#e6e6e6]">
                    <h3 className='text-xl font-semibold'>Add As-Planned model</h3>
                    <p className='text-sm mt-5 sm:w-[75%]'>Easily upload your 3D plant model to get started. Supported file formats include .obj. Drag and drop your files into the box below, or click to browse your device.</p>
                  </div>
                  <div className="mt-8">

                    <DropZone
                      onFilesAdded={(files) => setFormState({ ...formState, attachments: files })}
                    />
                  </div>
                </div>
              )
              }

              {/* {activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && mode === "create" && step === 4 && (
                  <div className="h-full ">
                    <div className="mt-8">
                      <h3 className='text-xl font-bold'>Upload Your Own</h3>
                      <p className='text-sm mt-5 sm:w-[75%]'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Esse doloremque deleniti ex ducimus quae! Animi temporibus harum voluptatem qui accusantium saepe fuga esse in magni, eligendi error incidunt amet! Aliquid?</p>
                    </div>
                    <div className="mt-8">

                      <DropZone
                        onFilesAdded={(files) => setFormState({ ...formState, attachments: files })}
                      />
                    </div>
                  </div>
                )
                } */}

              {/* { activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && mode === "create" && step === 5 && (
                  <div className="h-full ">
                    <h3
                      onClick={handleAddConnectionProfile}
                      className='text-lg text-end mb-2 cursor-pointer'>+ Add New Connection</h3>
                    <div className="h-[450px] overflow-y-auto">
                      {connectionProfiles && connectionProfiles.length > 0 && connectionProfiles.map((connectProfile) => {
                        return (
                          <div key={connectProfile.id} className={`w-full mt-3 h-[140px] p-4 px-8 border rounded-md bg-[#2A2A2A]`}>
                            <h3 className='text-xl'>{connectProfile.title}</h3>
                            <p className='sm:w-[75%] mt-2 text-sm leading-6'>{connectProfile.status}</p>
                            <h4
                              onClick={() => handleConnectionProfileDelete(connectProfile.id)}
                              className='text-[#F56262] text-end underline cursor-pointer mt-5'>Delete</h4>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )} */}
              {/* {mode === "create" && activeTab === "82000000-eaf8-488b-9993-12542d0dc61b"  && step === 3   &&  (
                  <div className="h-full mt-8">
                    <h3 className='text-xl font-semibold'>Software Licence Agreement</h3>
                      </div>
                      )} */}

              {((mode === "create" && activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4) || (activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4)) && (
                <div className="h-full text-[#e6e6e6] px-4 text-justify pl-6">
                  <h3 className='text-xl font-semibold'>Software Licence Agreement</h3>
                  <p className="mt-5 text-sm leading-[1.9]">
                    <strong>END USER LICENSE AGREEMENT (EULA) FOR SAAS USE OF PROCESSHUB</strong><br />
                    <strong>IMPORTANT – READ CAREFULLY:</strong><br />
                    This End User License Agreement (“Agreement”) is a legal agreement between you (either an individual or a single entity, referred to herein as “you” or “Licensee”) and <strong>Takamul Technologies</strong> (“Licensor”) for the use of the ProcessHub SaaS platform.<br />
                    <strong>BY CLICKING “ACCEPT,” OR BY INSTALLING, ACCESSING OR USING PROCESSHUB, YOU AGREE TO BE BOUND BY THIS AGREEMENT.</strong> IF YOU DO NOT AGREE TO THE TERMS OF THIS AGREEMENT, DO NOT INSTALL, ACCESS, OR USE PROCESSHUB.<br />
                    <br />
                    1. DEFINITIONS<br />
                    <strong>“ProcessHub”</strong> refers to the digital twin software solution owned by Takamul Technologies.<br />
                    <strong>“Services”</strong> means the hosted access and use of ProcessHub via a SaaS delivery model.<br />
                    <strong>“User Data”</strong> means all data submitted by Licensee or its users to ProcessHub.<br />
                    <strong>“Intellectual Property Rights”</strong> means all patents, copyrights, trademarks, trade secrets, and other intellectual property rights recognized worldwide.<br />
                    <br />
                    2. GRANT OF LICENSE<br />
                    Subject to your compliance with this Agreement, Takamul Technologies grants you a <strong>non-exclusive, non-transferable, non-sublicensable</strong> right to access and use ProcessHub for your internal business purposes only.<br />
                    <br />
                    3. LICENSE RESTRICTIONS<br />
                    You may not:<br />
                    - Reverse engineer, decompile, or disassemble ProcessHub.<br />
                    - Use ProcessHub for any unlawful, harmful, or abusive activity.<br />
                    - Modify, rent, lease, loan, sell, distribute, or create derivative works based on ProcessHub.<br />
                    - Share your access credentials or make ProcessHub available to third parties.<br />
                    <br />
                    4. INTELLECTUAL PROPERTY<br />
                    ProcessHub and all related components are the exclusive property of Takamul Technologies. This Agreement does not grant you any ownership rights to ProcessHub.<br />
                    <br />
                    5. DATA RIGHTS AND PRIVACY<br />
                    - You retain ownership of your User Data.<br />
                    - Takamul Technologies may process and store your data in accordance with applicable data protection laws (including GDPR, CCPA, and relevant Middle East regulations).<br />
                    - Security measures will be implemented to protect your data against unauthorized access.<br />
                    <br />
                    6. CONFIDENTIALITY<br />
                    You agree to keep confidential all non-public information disclosed by Takamul Technologies, including system architecture, documentation, and pricing information.<br />
                    <br />
                    7. COMPLIANCE WITH LAWS<br />
                    You agree to comply with all applicable international, federal, state, and local laws and regulations, including export laws, privacy laws, and cybersecurity regulations.<br />
                    <br />
                    8. WARRANTY DISCLAIMER<br />
                    ProcessHub is provided <strong>“AS IS”</strong> without warranties of any kind. Takamul Technologies does not guarantee uninterrupted or error-free operation of ProcessHub.<br />
                    <br />
                    9. LIMITATION OF LIABILITY<br />
                    To the maximum extent permitted by law, Takamul Technologies shall not be liable for indirect, incidental, special, or consequential damages. The total liability shall not exceed the amount paid for the service in the past six (6) months.<br />
                    <br />
                    10. TERMINATION<br />
                    This Agreement is effective until terminated. Your rights will automatically terminate without notice from Takamul Technologies if you fail to comply with any term(s). Upon termination, you must cease all use of ProcessHub and destroy all related materials.<br />
                    <br />
                    11. EXPORT AND SANCTIONS COMPLIANCE<br />
                    You may not use or access ProcessHub in violation of applicable export or sanctions laws.<br />
                    <br />
                    12. GOVERNING LAW<br />
                    This Agreement shall be governed by the laws of Saudi Arabia, without regard to its conflict of law principles. Disputes shall be resolved in accordance with the rules of courts of Dubai.<br />
                    <br />
                    13. MISCELLANEOUS<br />
                    - <strong>Entire Agreement:</strong> This is the entire agreement between you and Takamul Technologies regarding ProcessHub.<br />
                    - <strong>Modifications:</strong> Changes must be in writing and accepted by both parties.<br />
                    - <strong>Force Majeure:</strong> Neither party is liable for events beyond reasonable control.<br />
                    - <strong>Severability:</strong> If a provision is invalid, the rest of the agreement remains enforceable.<br />
                    - <strong>Assignment:</strong> You may not transfer your rights under this Agreement without prior written approval.<br />

                  </p>


                  <div className="flex  gap-3 mt-5 ">
                    <input
                      type="checkbox"
                      className='p-4 rounded-md  w-5 h-5'
                      checked={isAgreementChecked}
                      onChange={handleAgreementCheckboxChange}
                      id="terms-and-conditions"
                    />
                    <label htmlFor="terms-and-conditions" className='text-base'><strong>BY CLICKING “ACCEPT” OR USING PROCESSHUB, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD THIS AGREEMENT AND AGREE TO BE BOUND BY ITS TERMS.</strong></label>
                  </div>
                  <br />
                </div>
              )
              }

              {((mode === "create" && step === 5) || (mode === "create" && activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 5)) && (
                <div className="h-full ">
                  <h2 className="text-xl font-semibold mb-5">Confirm Project Details</h2>
                  {/* Confirmation Page - Show project details in a list format */}
                  <div className="bg-[#2A2A2A]/50 rounded-lg p-4 ">

                    <div>
                      <h3 className="text-lg font-medium mb-4 text-[#e6e6e6] border-b border-white/10 pb-2">
                        General Information
                      </h3>

                      <div className="">
                        <div className="grid grid-cols-2 gap-5 mt-5">
                          <div>
                            <label className="block text-xl font-medium text-[#e6e6e6] mb-1 px-2 py-1 rounded-md">Project Name : </label>
                            <p className="text-[#e6e6e6] text-base px-2 font-medium">{formState.projectName}</p>
                          </div>

                          <div>
                            <label className="block text-xl font-medium text-[#e6e6e6] mb-1 px-2 py-1 rounded-md">Project Visibility : </label>
                            <p className="text-[#e6e6e6] text-base px-2 font-medium">{formState.isPublic ? "Public" : "Private"}</p>
                          </div>
                        </div>
                       
                        <div className="grid grid-cols-2 gap-5 mt-5">
                          <div>
                            <label className="block text-xl font-medium text-[#e6e6e6] mb-1 px-2 py-1 rounded-md">Industry : </label>
                            <p className="text-[#e6e6e6] text-base px-2 font-medium">{selectedOption || formState.industry}</p>
                          </div>

                          <div>
                            <label className="block text-xl font-medium text-[#e6e6e6] mb-1 px-2 py-1 rounded-md">Project Type : </label>
                            <p className="text-[#e6e6e6] text-base px-2 font-medium">{formState.projectType}</p>
                          </div>
                        </div>

                      
                        <div className=" grid grid-cols-2 gap-5 mt-5">
                          {activeTab !== "progress" && (
                            <div>
                              <label className="block text-xl font-medium text-[#e6e6e6] mb-1 px-2 py-1 rounded-md">Logo : </label>
                              {formState.logoPreview ? (
                                <img src={formState.logoPreview} alt="Logo" className="h-[50px] w-[60px] object-contain rounded-md" />
                              ) : (
                                <p className="text-[#e6e6e6] text-base px-2 font-medium">No logo uploaded</p>
                              )}
                            </div>
                          )}
                          {formState.desc && (
                            <div className=''>
                              <h3 className="block text-xl font-medium text-[#e6e6e6] mb-1 px-2 py-1 rounded-md">
                                Description :
                              </h3>
                              <p className="text-[#e6e6e6] text-base px-2 font-medium">{formState.desc}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className='mt-8'>
                      <h3 className="text-lg font-medium mb-4 text-[#e6e6e6] border-b border-white/10 pb-2">
                        Location Details
                      </h3>

                      <div className="grid grid-cols-2 gap-5 mt-5">
                        <div>
                          <label className=" block text-xl font-medium text-[#e6e6e6] mb-1  px-2 py-1 rounded-md">Region : </label>
                          <p className="text-[#e6e6e6] text-base px-2 font-medium">{formState.productLocation}</p>
                        </div>

                        <div>
                          <label className="block text-xl font-medium text-[#e6e6e6] mb-1  px-2 py-1 rounded-md">Coordinates : </label>
                          <div className="flex items-center">
                            <FiMapPin className="text-gray-400 mr-2" />
                            <p className="text-[#e6e6e6] text-base px-2 font-medium">
                              {formState.coordinates[0] !== null && formState.coordinates[1] !== null
                                ? `${formState.coordinates[0].toFixed(6)}, ${formState.coordinates[1].toFixed(6)}`
                                : 'Not specified'}
                            </p>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                  <br />
                </div>
              )}

              {mode === "edit" && (
                <div className="h-full">
                  <h2 className="text-2xl font-semibold mb-8">Edit Project</h2>
                  <NewProjectForm
                    from={from}
                    setStep={setStep}
                    onSaveSubmitFunction={handleSaveSubmitFunction}
                    setIsModalOpen={setIsModalOpen}
                    isModalOpen={isModalOpen}
                    goNext={goNext}
                    goBack={goBack}
                    step={step}
                    selectedOption={selectedOption}
                    isLoading={isLoading}
                    setNewProjectModal={setNewProjectModal}
                    setRefreshMode={setRefreshMode}
                    setError={setError}
                    mode="edit"
                    formState={formState}
                    setFormState={setFormState}
                    setIsLoading={setIsLoading}
                    selectedOrganization={selectedOrganization}
                    selectedProject={selectedProject}
                    activeTab={activeTab}
                  />
                </div>
              )}
            </div>

 {/* Navigation */}
 {mode === "create" ? (
              <div className="flex justify-between gap-10 p-6 py-4  sticky top-0 bg-[#1A1A1A]/0 items-center   w-full z-10 rounded-lg mt-2">
                {/* <button
                  onClick={handleClose}
                  className="absolute top-[28px] right-4 text-gray-400 hover:text-white"
                >
                  <FiX size={24} />
                </button> */}

                {activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step !== 1 && step !== 2 && step !== 4 && step !== 5 && step !== 6 && <h4 onClick={handleSkip} className="absolute top-[15px] underline left-24 text-gray-400 hover:text-white cursor-pointer">Skip</h4>}

                {step !== 1 ? (
                  <div className={`p-[1.5px] rounded-md ${selectedOption ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                    <button
                      onClick={goBack}
                      className={`flex flex-row items-center gap-2 ${selectedOption ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                    >
                      {/* <SlArrowLeft /> */}
                      Back
                    </button>
                  </div>
                ) : (
                  <div className="w-[44px]" />
                )}

                

                <div className="flex gap-5 items-center justify-end">
                <div className={` rounded-md  relative bottom-[10px]`}>
                  <button
                  className={`flex flex-row items-center gap-2 hover:text-gray-400 hover:underline text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                  onClick={handleClose}
                  >Cancel</button>
                  </div>
                  {step === 1 && (
                    <>
                      <div className={`p-[1.5px] rounded-md ${selectedOption ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 ${selectedOption ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                          disabled={!selectedOption}
                        >
                          Continues
                        </button>
                      </div>
                    </>
                  )}
                  {activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step === 3 && (
                    <>
                      <div className={`p-[1.5px] rounded-md ${selectedAsset ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 ${selectedAsset ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                          disabled={!selectedAsset}
                        >
                          {/* <SlArrowRight /> */}
                          Continue
                        </button>
                      </div>
                    </>
                  )}
                  {activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 3 && (
                     <div className={`p-[1.5px] rounded-md bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] relative bottom-[10px]`}>
                     <button
                       onClick={goNext}
                       className={`flex flex-row items-center gap-2  bg-[#2A2A2A] hover:bg-[#3a3a3a33] rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
               
                     >
                       {/* <SlArrowRight /> */}
                       Continue
                     </button>
                   </div>
                  )
                  }

                  {/* {activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4 && (
                      <>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold  mb-[25px] ${selectedAsset
                            ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white hover:opacity-90'
                            : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'
                            }`}
                          disabled={!selectedAsset}
                        >
                          <SlArrowRight />
                        </button>
                      </>
                    )} */}

                  {/* {step === 5 && (
                      <>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold  mb-[25px] ${selectedAsset
                            ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white hover:opacity-90'
                            : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'
                            }`}
                          disabled={!selectedAsset}
                        >
                          <SlArrowRight />
                        </button>
                      </>
                    )} */}
                  {/* ((mode === "create" && step === 5) || (activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step === 3)) */}

                  {/* {mode === "create" && activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4 && (
                      <>
                        <div className="p-[1.5px] rounded-md bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] relative bottom-[10px]">
                          <button
                            onClick={goNext}
                            className="flex flex-row items-center gap-2 bg-[#2A2A2A] hover:bg-[#3a3a3a33] rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full"
                          >
                            <SlArrowRight />
                          </button>
                        </div>
                      </>
                    )} */}

                  {((mode === "create" && activeTab !== "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4) || (activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 4)) && (
                    <>
                      <div className={`p-[1.5px] rounded-md ${isAgreementChecked ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                        <button
                          onClick={goNext}
                          className={`flex flex-row items-center gap-2 ${isAgreementChecked ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                          disabled={!isAgreementChecked}
                        >
                          {/* <SlArrowRight /> */}
                          Continue
                        </button>
                      </div>
                    </>
                  )}

                  {step === 2 && (
                    <div className={`p-[1.5px] rounded-md ${formState.projectName && formState.productLocation ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3]' : 'bg-[#2A2A2A]'} relative bottom-[10px]`}>
                      <button
                        onClick={goNext}
                        className={`flex flex-row items-center gap-2 ${formState.projectName && formState.productLocation ? 'bg-[#2A2A2A] hover:bg-[#3a3a3a33]' : 'bg-[#2A2A2A] text-gray-400 cursor-not-allowed'} rounded-md p-3 py-2 text-center text-sm 2xl:text-md font-bold text-white w-full h-full`}
                        disabled={!formState.projectName || !formState.productLocation}
                      >
                        {/* <SlArrowRight /> */}
                        Continue
                      </button>
                    </div>
                  )}

                  {/* {step === 6 && ( */}
                  {((mode === "create" && step === 5) || (activeTab === "82000000-eaf8-488b-9993-12542d0dc61b" && step === 5)) && (
                    <div className="p-[1.5px] rounded-md bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] relative bottom-[10px]">
                      <AddNewItemBtn
                        onClick={handleSubmitFromStep3}
                        className='bg-[#2A2A2A] hover:bg-[#3a3a3a33] text-white hover:opacity-90 w-full h-full'
                        btnType="filled"
                        type="button"
                        isDisabled={isLoading || !submitProjectForm}
                      >
                        {isLoading ? (
                          <SmallLoader />
                        ) : (
                          <div className="flex items-center">
                            <FiCheck className="mr-2" />
                            <span> Create</span>
                          </div>
                        )}
                      </AddNewItemBtn>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="flex justify-end items-center mb-2 mt-2">
                <div className="flex gap-2 items-center">
       {from === "projectsHome" &&           <RemoveItemBtn
                    onClick={openModal}
                    isDisabled={false}
                    type="button"
                  >
                    Remove Project
                  </RemoveItemBtn>}

                  <AddNewItemBtn
                    btnType="filled"
                    type="button"
                    isDisabled={isLoading}
                    className='mr-3'
                    onClick={handleSubmitFromStep3}
                  >
                    {isLoading ? <SmallLoader /> : <span>Update Project</span>}
                  </AddNewItemBtn>
                </div>
              </div>
            )}
          </div>
          {/* </BorderGradient> */}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
